import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'CustomObjectsServices'
const host = servicesConfig.CustomObjects
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const CustomObjectsService = {
  Schemas: {
    getSchemasByLocationId: (locationId: string) => 
      request().get(`/?locationId=${locationId}`).then(responseBody),
      
    getByKey: (key: string, locationId: string) => 
      request().get(`/${key}/?locationId=${locationId}`).then(responseBody)
  }
}

export default CustomObjectsService
